<div class="flex flex-col h-full bg-slate-50">
  <!-- Messages Area -->
  <div #messagesContainer class="flex-1 overflow-y-auto p-4 space-y-4 scroll-smooth">
    @for (message of messages; track message.id) {
      <div class="flex gap-3" [class.justify-end]="message.isUser">
        @if (!message.isUser) {
          <div
            class="w-8 h-8 rounded-lg bg-primary/10 flex-shrink-0 flex items-center justify-center"
          >
            <img src="assets/accessibility/hudumaAI.png" class="w-5 h-5" alt="AI" />
          </div>
        }

        <div
          class="max-w-[80%] px-4 py-3 rounded-2xl text-sm leading-relaxed"
          [class.bg-primary]="!message.isUser"
          [class.text-white]="!message.isUser"
          [class.rounded-tl-none]="!message.isUser"
          [class.bg-white]="message.isUser"
          [class.text-slate-800]="message.isUser"
          [class.rounded-tr-none]="message.isUser"
          [class.shadow-sm]="message.isUser"
        >
          {{ message.content }}

          <!-- Loading -->
          @if (message.isLoading) {
            <span class="inline-flex gap-1 ml-1">
              <span class="w-1.5 h-1.5 bg-white/70 rounded-full animate-bounce"></span>
              <span class="w-1.5 h-1.5 bg-white/70 rounded-full animate-bounce delay-100"></span>
              <span class="w-1.5 h-1.5 bg-white/70 rounded-full animate-bounce delay-200"></span>
            </span>
          }

          <!-- Typing -->
          @if (message.isStreaming && !message.isLoading) {
            <span
              class="inline-block w-0.5 h-4 bg-white/80 ml-0.5 animate-pulse align-middle"
            ></span>
          }
        </div>

        @if (message.isUser) {
          <div
            class="w-8 h-8 rounded-full bg-slate-300 flex-shrink-0 flex items-center justify-center"
          >
            <svg
              class="w-4 h-4 text-slate-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
              />
            </svg>
          </div>
        }
      </div>
    }
  </div>

  <!-- Input Area -->
  <div class="p-4 bg-white border-t border-slate-200 shrink-0">
    <div class="flex gap-2">
      <input
        type="text"
        [(ngModel)]="inputMessage"
        (keydown)="onKeydown($event)"
        [disabled]="!sessionId"
        [placeholder]="placeholderText"
        class="flex-1 px-4 py-3 rounded-xl bg-slate-100 border-0 text-slate-800 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-primary/50 transition-all"
      />
      <button
        (click)="sendMessageStream()"
        [disabled]="!inputMessage.trim() || !sessionId"
        class="px-4 py-3 rounded-xl bg-primary text-white grid place-items-center hover:bg-primary/90 disabled:opacity-80 disabled:cursor-not-allowed transition-all hover:scale-105 active:scale-95"
      >
        <app-svg-icon name="send-icon" class="w-5 h-5 text-white" />
      </button>
    </div>
  </div>
</div>
